import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.80)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    marginLeft: 25,
    marginTop: 5,
  },
}))(Tooltip);

export default LightTooltip;